/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Pit1_DInputs */

const en_csv_to_json_pit1_d = /** @type {(inputs: Csv_To_Json_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numbers arrive as strings, so a sum over a column will concatenate instead of adding, and a comparison will order 100 before 20. Map the columns you know are numeric after conversion. Do not reach for a converter that guesses, because it will guess wrong on identifiers and postal codes.`)
};

const ko_csv_to_json_pit1_d = /** @type {(inputs: Csv_To_Json_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숫자가 문자열로 도착하므로, 어떤 열의 합계는 더하기가 아니라 이어붙이기가 되고, 비교는 100을 20보다 앞에 놓습니다. 변환 후에 숫자라고 아는 열을 매핑하세요. 추측하는 변환기를 찾지 마세요. 식별자와 우편번호에서 반드시 틀립니다.`)
};

const ja_csv_to_json_pit1_d = /** @type {(inputs: Csv_To_Json_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値が文字列として届くので、ある列の合計は加算ではなく連結になり、比較は 100 を 20 より前に並べます。変換後に、数値だと分かっている列をマッピングしてください。推測する変換器に手を伸ばさないでください。識別子や郵便番号で必ず間違えます。`)
};

/**
* | output |
* | --- |
* | "Numbers arrive as strings, so a sum over a column will concatenate instead of adding, and a comparison will order 100 before 20. Map the columns you know are..." |
*
* @param {Csv_To_Json_Pit1_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_pit1_d = /** @type {((inputs?: Csv_To_Json_Pit1_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Pit1_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_pit1_d(inputs)
	if (locale === "ko") return ko_csv_to_json_pit1_d(inputs)
	return ja_csv_to_json_pit1_d(inputs)
});